import React, { useEffect, useState } from 'react';
import '../assets/css/custom.css';
import '../assets/css/client.css';
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/steps.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, Link } from "react-router-dom";
import { faTrashCan, faPenToSquare, } from '@fortawesome/free-solid-svg-icons';
import NoBuilding from "../assets/img/no-building.png";
import { commonAPI } from "../services/CommonAPIService"
import Menus from "./menus";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ErrorSource } from "../common/constants";

function SelectBuilding() {

    const [show, setShow] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [BuildingList, setBuildingList] = useState();
    const history = useNavigate();
    

   

    const GetCuroNextUserMappingApi = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        console.log("userId is", myUserData);
        const bodyData = {
            "userId": myUserData?.userId,
            // "userId": 10143,
            "userImageRequired": false,
            "buildingLogoRequired": true
        }

        try {
            console.log("Select Building body", bodyData)
            let response = await commonAPI("GetCuroNextUserMapping", bodyData)
            setLoading(true);
            console.log("Select Building table", response?.data)

            if(response.success == true && response.message.length == 0) {
                setLoading(false);
                setBuildingList(response?.data)
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/User/GetCuroNextUserMapping",
                "errorNumber": "GUM01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "selectBuilding.js",
                "functionName": "GetCuroNextUserMappingApi",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    useEffect(() => {
        GetCuroNextUserMappingApi();
    }, [])


    const SelectBuildingData = (item) => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        console.log("item", item)
        if(item?.roleName == "Support Admin"){
            if (!item.isActive && !item?.isActiveUser){
                toast.error("Your account is inactive");
            }else if (!item?.isActiveBuilding){
                toast.error("Your building is inactive");
            }else if (!item?.isActiveClient){
                toast.error("Your client is inactive");
            }else{
                const dataToUpdate = {
                    ...myUserData,
                    loginCount : 1,
                    // loginMessage : 1,
                    familyGroupId: item?.familyGroupId,
                    userMappingId: item?.userMappingId,
                    buildingId: item?.buildingId,
                    buildingName: item?.buildingName,
                    flatId: item?.flatId,
                    flatName: item?.flatName,
                    roleId: item?.roleId,
                    roleName: item?.roleName,
                    IsParent: item?.IsParent,
                    currentStatus: item?.currentStatus,
                    familyGroupId: item?.familyGroupId,
                    isActiveBuilding: item?.isActiveBuilding,
                    isActiveClient: item?.isActiveClient,
                    isActiveRole: item?.isActiveRole,
                    isActiveUser: item?.isActiveUser,
                    isActive: item?.isActive,
                    logo: item?.logo,
                    addressLine1: item?.addressLine1,
                    addressLine2: item?.addressLine2,
                    city: item?.city,
                    state: item?.state
                }
                console.log("dataToUpdate1111", dataToUpdate);
                // console.log("data Mapping", responseMapping);
                localStorage.setItem("userData", JSON.stringify(dataToUpdate))
                // toast.success("Login Successfully");
                
                history('/Dashboard');
                
            }
        }else {
            if (!item?.isActive && !item?.isActiveUser){
                toast.error("Your account is inactive");
            }else if (!item?.isActiveBuilding){
                toast.error("Your building is inactive");
            }else if (!item?.isActiveClient){
                toast.error("Your client is inactive");
            }else{
                const dataToUpdate = {
                    ...myUserData,
                    loginCount : 1,
                    // loginMessage : 1,
                    familyGroupId: item?.familyGroupId,
                    userMappingId: item?.userMappingId,
                    buildingId: item?.buildingId,
                    buildingName: item?.buildingName,
                    flatId: item?.flatId,
                    flatName: item?.flatName,
                    roleId: item?.roleId,
                    roleName: item?.roleName,
                    IsParent: item?.IsParent,
                    currentStatus: item?.currentStatus,
                    familyGroupId: item?.familyGroupId,
                    isActiveBuilding: item?.isActiveBuilding,
                    isActiveClient: item?.isActiveClient,
                    isActiveRole: item?.isActiveRole,
                    isActiveUser: item?.isActiveUser,
                    isActive: item?.isActive,
                    logo: item?.logo,
                    addressLine1: item?.addressLine1,
                    addressLine2: item?.addressLine2,
                    city: item?.city,
                    state: item?.state
                }
                console.log("dataToUpdate2222", dataToUpdate);
                // console.log("data Mapping", responseMapping);
                localStorage.setItem("userData", JSON.stringify(dataToUpdate))
                // toast.success("Login Successfully");
                history('/Dashboard');

            }
        }
    }


    return (
        <>
            {Loading ?
                <div className="loaderDiv">
                    <div className="loader"></div>
                </div>
                : null}
            <ToastContainer />
            <Menus />
            <div className='container-fluid'>
                <div className="row mt-5 pt-2" style={{ alignItem: 'center' }}>
                    <div className="col-lg-6 col-md-6">
                        <div className="HeadingTop">
                            <h3> Select Buildings </h3>
                            <span> List of Curo Solution Buildings</span>
                        </div>
                    </div>
                </div>

                {/* {ClientList?.length && */}
                <div className='row'>
                    {BuildingList ? BuildingList.map((item, index) =>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
                            <div className='clientTiles' style={{ height: 200 }} onClick={() => SelectBuildingData(item)}>
                                <div className="ClientImg">
                                    <div className="tabs_img">
                                        <img src={item?.logo} class="img img-responsive" alt="client-img" />
                                    </div>
                                    {/* <div class="bars_font">
                                        <h3 className="font_trigger">
                                            <FontAwesomeIcon icon={faPenToSquare} />
                                        </h3>
                                        <h3 className="font_trigger" >
                                            <FontAwesomeIcon icon={faTrashCan} />
                                        </h3>
                                    </div> */}
                                </div>
                                <div className='ClientText' >
                                    <div className="l-two">
                                        <h1> {item?.buildingName} </h1>
                                        <h4> {item?.clientDisplayName} </h4>
                                        <h4> {item?.email} </h4>
                                        <h4> {item?.phoneNumber}</h4>
                                        <h4> {item?.addressLine1} {item?.addressLine2}</h4>
                                        <h4> {item?.city}, {item?.state}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
                {/* } */}
                {!BuildingList?.length && BuildingList?.length != null &&
                    <div className='bg-white' style={{ paddingBottom:"50px",  borderRadius: "10px" }}>
                        <div className='col-12 text-center'>
                            <img src={NoBuilding} alt="user" class="mx-auto mt-5" style={{ height: "100px" }} />
                        </div>
                        <br />
                        <h3 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "0px" }}> No building found</h3>
                        <h5 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "10px" }}> Click on Create New button to add a building</h5>
                    </div>}
            </div>        
           
           

            
        </>
    )

}
export default SelectBuilding